<script setup lang="ts" name="SailingScheduleTradeLaneActions">
const { idle } = defineProps<{
  idle: boolean;
}>();
</script>

<template>
  <div
    class="ml-auto flex items-center gap-4"
    :class="{
      'pointer-events-none opacity-50': !idle,
    }"
  >
    <slot />
  </div>
</template>
